'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StickyToolbar = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _utilsBrowser = require('@bibliocommons/utils-browser');

require('../styles/StickyToolbar.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StickyToolbar = exports.StickyToolbar = function (_BcReactComponent) {
  _inherits(StickyToolbar, _BcReactComponent);

  function StickyToolbar(props) {
    _classCallCheck(this, StickyToolbar);

    var _this = _possibleConstructorReturn(this, (StickyToolbar.__proto__ || Object.getPrototypeOf(StickyToolbar)).call(this, props));

    _this.handleScroll = _lodash2.default.throttle(_this.handleScroll, 50).bind(_this);
    _this.handleResize = _lodash2.default.throttle(_this.updateOffsets, 50).bind(_this);

    _this.state = {
      stickToTop: false,
      initialOffset: 0,
      toolbarHeight: 0,
      toolbarWidth: 0,
      toolbarLeft: 0,
      toolbarTop: 0
    };
    return _this;
  }

  _createClass(StickyToolbar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('resize', this.handleResize);

      setTimeout(function () {
        _this2.updateOffsets();
        _this2.handleScroll();
      }, 0);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'shouldStickToTop',
    value: function shouldStickToTop(toolbarTop) {
      return (0, _utilsBrowser.getScrollTop)() > this.state.initialOffset - toolbarTop;
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      this.updateOffsets();

      var changes = {};

      changes.toolbarTop = this.props.getOffsetForStickyToolbar ? this.props.getOffsetForStickyToolbar() : 0;

      var shouldStickToTop = this.shouldStickToTop(changes.toolbarTop);

      if (this.state.stickToTop !== shouldStickToTop) {
        changes.stickToTop = shouldStickToTop;
      }

      this.setState(changes);
    }
  }, {
    key: 'updateOffsets',
    value: function updateOffsets() {
      var _this3 = this;

      var changes = {};

      if (this._toolbarDiv) {
        changes.initialOffset = this._toolbarDiv.getBoundingClientRect().top + window.pageYOffset - document.documentElement.clientTop;
        var rect = this._toolbarDiv.getBoundingClientRect();
        changes.toolbarLeft = rect.left;
        changes.toolbarWidth = rect.width;
      }

      this.setState(changes, function () {
        _this3.updateToolbarHeight();
      });
    }
  }, {
    key: 'updateToolbarHeight',
    value: function updateToolbarHeight() {
      if (this._toolbarContentsWrapper) {
        this.setState({
          toolbarHeight: this._toolbarContentsWrapper.clientHeight
        });
      }
    }
  }, {
    key: 'getWrapperStyle',
    value: function getWrapperStyle() {
      if (this.state.stickToTop) {
        return {
          top: this.state.toolbarTop + 'px',
          left: this.state.toolbarLeft + 'px',
          width: this.state.toolbarWidth + 'px'
        };
      }

      return {};
    }
  }, {
    key: 'renderToolbarPlaceholder',
    value: function renderToolbarPlaceholder() {
      // Renders a div with the same height as the toolbar
      //
      // This is intended to preserve the vertical position of elements on
      // the page when the toolbar switches from to the sticky version.
      if (this.state.stickToTop) {
        return _react2.default.createElement('div', { style: { height: this.state.toolbarHeight } });
      }

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return _react2.default.createElement(
        'div',
        {
          className: (0, _classnames2.default)('cp-sticky-toolbar', this.props.className),
          ref: function ref(el) {
            _this4._toolbarDiv = el;
          } },
        _react2.default.createElement(
          'div',
          {
            className: (0, _classnames2.default)('toolbar-contents-wrapper', { sticky: this.state.stickToTop }),
            style: this.getWrapperStyle(),
            ref: function ref(el) {
              return _this4._toolbarContentsWrapper = el;
            } },
          this.props.children
        ),
        this.renderToolbarPlaceholder()
      );
    }
  }]);

  return StickyToolbar;
}(_baseBcReactComponent2.default);

StickyToolbar.propTypes = {
  className: _react.PropTypes.string,
  getOffsetForStickyToolbar: _react.PropTypes.func,
  children: _react.PropTypes.oneOfType([_react.PropTypes.arrayOf(_react.PropTypes.node), _react.PropTypes.node]).isRequired
};

exports.default = StickyToolbar;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-sticky-toolbar/lib/components/StickyToolbar.component.js
// module id = 1194
// module chunks = 0